import { yupResolver } from "@hookform/resolvers/yup";
import { mixed, number, object, string } from "yup";

const schema = object({
  remote_uid: number().typeError("Store ID must be a number").required("Store ID is required"),
  name: string().label("Name").required("Name is required"),
  organization_id: mixed().required("Organization is required"),
  clubready_chain_id: mixed().required("Chain is required")
}).required();

export const schemaResolver = yupResolver(schema);
